import { memo, useCallback } from 'react';
import { useNavigate } from 'react-router';

import styles from './StickyPromoBanner.module.css';
import { Breakpoint, Button, Image, useBreakpoint } from '@betty/moonlight';
import { useSelector } from '@betty/toolkit/state';
import { selectIsClaimPromoButtonVisible } from '@betty/auth';

function StickyPromoBanner() {
  const navigate = useNavigate();

  const breakpoint = useBreakpoint();
  const isMobile = breakpoint === Breakpoint.MOBILE;

  const isClaimPromoButtonVisible = useSelector(
    selectIsClaimPromoButtonVisible,
  );

  const onJoinPress = useCallback(() => {
    navigate('/register');
  }, [navigate]);

  if (isClaimPromoButtonVisible === undefined || isClaimPromoButtonVisible)
    return null;

  return (
    <div className={styles.stickyPromoBanner}>
      <div className={styles.promoBannerImage}>
        <Image
          name={
            isMobile
              ? 'landingPage.promoCharacters'
              : 'landingPage.promoCharactersDesktop'
          }
          width={{
            desktop: 222,
            tablet: 222,
            mobile: 172,
          }}
          height={{
            desktop: 113,
            tablet: 113,
            mobile: 116,
          }}
        />
      </div>
      <Button
        variant="primary"
        size="small"
        onPress={onJoinPress}
        rightIcon="arrowForward"
        locKey="claimYourBonus"
      />
    </div>
  );
}

export default memo(StickyPromoBanner);
